import { Action } from 'redux';

export const SUPER_GET_PENDING_FULFILLMENT = 'super-admin-rydin-fulfillments/SUPER_GET_PENDING_FULFILLMENT';
export const getSuperPendingFulfillment = () => ({
  type: SUPER_GET_PENDING_FULFILLMENT,
});
export const SUPER_SET_PENDING_FULFILLMENT = 'super-admin-rydin-fulfillments/SUPER_SET_PENDING_FULFILLMENT';
export const setSuperPendingFulfillment = (data: ReadonlyArray<SuperPendingFulfilmentTable>) => ({
  type: SUPER_SET_PENDING_FULFILLMENT,
  payload: data,
});

export const SUPER_GET_COMPLETED_FULFILLMENT = 'super-admin-rydin-fulfillments/SUPER_GET_COMPLETED_FULFILLMENT';
export const getSuperCompletedFulfillment = (data: SelectReportData) => ({
  type: SUPER_GET_COMPLETED_FULFILLMENT,
  payload: data,
});
export const SUPER_SET_COMPLETED_FULFILLMENT = 'super-admin-rydin-fulfillments/SUPER_SET_COMPLETED_FULFILLMENT';
export const setSuperCompletedFulfillment = (data: ReadonlyArray<SuperCompletedFulfilmentTable>) => ({
  type: SUPER_SET_COMPLETED_FULFILLMENT,
  payload: data,
});

export const SUPER_GET_FULFILLMENT_BATCHES = 'super-admin-rydin-fulfillments/SUPER_GET_FULFILLMENT_BATCHES';
export const getSuperFulfillmentBatches = (data: SelectReportData) => ({
  type: SUPER_GET_FULFILLMENT_BATCHES,
  payload: data,
});

export const SUPER_SET_FULFILLMENT_BATCHES = 'super-admin-rydin-fulfillments/SUPER_SET_FULFILLMENT_BATCHES';
export const setSuperFulfillmentBatches = (data: ReadonlyArray<SuperFulfilmentBatchesTable>) => ({
  type: SUPER_SET_FULFILLMENT_BATCHES,
  payload: data,
});
//multiple client table//

export const SUPER_GET_MULTIPLE_CLIENTS = 'super-admin-rydin-fulfillments/SUPER_GET_MULTIPLE_CLIENTS';
export const getSuperMultipleClients = () => ({
  type: SUPER_GET_MULTIPLE_CLIENTS,
});

export const SUPER_SET_MULTIPLE_CLIENTS = 'super-admin-rydin-fulfillments/SUPER_SET_MULTIPLE_CLIENTS';
export const setSuperMultipleClients = (data: ReadonlyArray<SuperMultipleClients>) => ({
  type: SUPER_SET_MULTIPLE_CLIENTS,
  payload: data,
});
//  print bult batches

export const SUPER_GET_PRINT_BULK_BATCHES = 'super-admin-rydin-fulfillments/SUPER_GET_PRINT_BULK_BATCHES';
export const getSuperPrintBulkBatches = (data: any) => ({
  type: SUPER_GET_PRINT_BULK_BATCHES,
  payload: data,
});

export const SUPER_SET_PRINT_BULK_BATCHES = 'super-admin-rydin-fulfillments/SUPER_SET_PRINT_BULK_BATCHES';
export const setSuperPrintBulkBatches = (data: ReadonlyArray<SuperPrintBulkBatches>) => ({
  type: SUPER_SET_PRINT_BULK_BATCHES,
  payload: data,
});

//processing result//
export const SUPER_GET_FULFILLMENT_PROCESSING_RESULT =
  'super-admin-rydin-fulfillments/SUPER_GET_FULFILLMENT_PROCESSING_RESULT';
export const getSuperFulfillmentProccessingResult = (data: any) => ({
  type: SUPER_GET_FULFILLMENT_PROCESSING_RESULT,
  payload: data,
});

export const SUPER_START_POLLING_FULFILLMENT_RESULT =
  'super-admin-rydin-fulfillments/SUPER_START_POLLING_FULFILLMENT_RESULT';
export const startPollingFulfillmentResult = (trackingId: string) => ({
  type: SUPER_START_POLLING_FULFILLMENT_RESULT,
  payload: trackingId,
});

export const SUPER_STOP_POLLING_FULFILLMENT_RESULT =
  'super-admin-rydin-fulfillments/SUPER_STOP_POLLING_FULFILLMENT_RESULT';
export const stopPollingFulfillmentResult = () => ({
  type: SUPER_STOP_POLLING_FULFILLMENT_RESULT,
});

export const SUPER_SET_FULFILLMENT_PROCESSING_RESULT =
  'super-admin-rydin-fulfillments/SUPER_SET_FULFILLMENT_PROCESSING_RESULT';
export const setSuperFulfillmentProccessingResult = (data: any) => ({
  type: SUPER_SET_FULFILLMENT_PROCESSING_RESULT,
  payload: data,
});

export const SUPER_GET_PENDING_FULFILLMENT_PRINT_BATCH =
  'super-admin-rydin-fulfillments/SUPER_GET_PENDING_FULFILLMENT_PRINT_BATCH';
export const getSuperPendingfulfillmentPrintBatch = (data: any) => ({
  type: SUPER_GET_PENDING_FULFILLMENT_PRINT_BATCH,
  payload: data,
});

export const SUPER_SET_PENDING_FULFILLMENT_PRINT_BATCH =
  'super-admin-rydin-fulfillments/SUPER_SET_PENDING_FULFILLMENT_PRINT_BATCH';
export const setSuperPendingfulfillmentPrintBatch = (data: any) => ({
  type: SUPER_SET_PENDING_FULFILLMENT_PRINT_BATCH,
  payload: data,
});

// fulfillment Process batch//
// export const SUPER_GET_FULFILLMENTS_PROCESS_BATCH_MULTIPLE_CLIENTS = 'super-admin-rydin-fulfillments/SUPER_GET_FULFILLMENTS_PROCESS_BATCH_MULTIPLE_CLIENTS';
// export const getSuperFulfillmentsProcessBatchMultipleClients = () => ({
//   type: SUPER_GET_FULFILLMENTS_PROCESS_BATCH_MULTIPLE_CLIENTS
// })

// export const SUPER_SET_FULFILLMENTS_PROCESS_BATCH_MULTIPLE_CLIENTS = 'super-admin-rydin-fulfillments/SUPER_SET_FULFILLMENTS_PROCESS_BATCH_MULTIPLE_CLIENTS'
// export const setSuperFulfillmentsProcessBatchMultipleClients  = (data: ReadonlyArray<FulfillmentsProcessBatchMultipleClientsFormValues>) => ({
//   type: SUPER_SET_FULFILLMENTS_PROCESS_BATCH_MULTIPLE_CLIENTS,
//   payload: data
// })

// // Process Batch multiple client Action //
// export interface SuperSetFulfillmentsProcessBatchMultipleClientsAction extends Action<typeof SUPER_SET_FULFILLMENTS_PROCESS_BATCH_MULTIPLE_CLIENTS> {
//   payload: ReadonlyArray<FulfillmentsProcessBatchMultipleClientsFormValues>;
// }

export const SUPER_GET_FULFILLMENTS_PROCESS_BATCH_MULTIPLE_CLIENTS =
  'super-admin-rydin-fulfillments/SUPER_GET_FULFILLMENTS_PROCESS_BATCH_MULTIPLE_CLIENTS';
export const getSuperFulfillmentsProcessBatchMultipleClients = (
  data: FulfillmentsProcessBatchMultipleClientsFormValues,
  onComplete?: () => void,
) => ({
  meta: {
    onComplete,
  },
  type: SUPER_GET_FULFILLMENTS_PROCESS_BATCH_MULTIPLE_CLIENTS,
  payload: data,
});

export const SUPER_SET_FULFILLMENTS_PROCESS_BATCH_MULTIPLE_CLIENTS =
  'super-admin-rydin-fulfillments/SUPER_SET_FULFILLMENTS_PROCESS_BATCH_MULTIPLE_CLIENTS';
export const setSuperFulfillmentsProcessBatchMultipleClients = (
  data: FulfillmentsProcessBatchMultipleClientsFormValues | any | undefined,
  onComplete?: () => void,
) => ({
  meta: {
    onComplete,
  },
  type: SUPER_SET_FULFILLMENTS_PROCESS_BATCH_MULTIPLE_CLIENTS,
  payload: data,
});
export interface SuperSetFulfillmentsProcessBatchMultipleClientsAction
  extends Action<typeof SUPER_SET_FULFILLMENTS_PROCESS_BATCH_MULTIPLE_CLIENTS>, OnCompleteAction {
  readonly payload: FulfillmentsProcessBatchMultipleClientsFormValues | undefined;
}

//multiple client Action //
export interface SuperSetMultipleClientsAction extends Action<typeof SUPER_SET_MULTIPLE_CLIENTS> {
  payload: ReadonlyArray<SuperMultipleClients>;
}
//print bulk batches //

export interface SuperSetPrintBulkBathcesAction extends Action<typeof SUPER_SET_PRINT_BULK_BATCHES> {
  payload: ReadonlyArray<SuperPrintBulkBatches>;
}

export interface SuperSetPendingFulfillmentAction extends Action<typeof SUPER_SET_PENDING_FULFILLMENT> {
  payload: ReadonlyArray<SuperPendingFulfilmentTable>;
}

export interface SuperSetCompletedFulfillmentAction extends Action<typeof SUPER_SET_COMPLETED_FULFILLMENT> {
  payload: ReadonlyArray<SuperCompletedFulfilmentTable>;
}

export interface SuperSetFulfillmentBatchesAction extends Action<typeof SUPER_SET_FULFILLMENT_BATCHES> {
  payload: ReadonlyArray<SuperFulfilmentBatchesTable>;
}
export interface SetSuperFulfillmentProccessingResultAction extends Action<
  typeof SUPER_SET_FULFILLMENT_PROCESSING_RESULT
> {
  payload: any;
}
//  super print bulk batches

export const SUPER_PRINT_FULFILLMENT_BATCH = 'super-admin-rydin-fulfillments/SUPER_PRINT_FULFILLMENT_BATCH';
export const superPrintfulfillmentBatch = (data: any) => ({
  type: SUPER_PRINT_FULFILLMENT_BATCH,
  payload: data,
});
export const SET_SUPER_PRINT_FULFILLMENT_BATCH = 'super-admin-rydin-fulfillments/SET_SUPER_PRINT_FULFILLMENT_BATCH';
export const setSuperPrintfulfillmentBatch = (data: any) => ({
  type: SET_SUPER_PRINT_FULFILLMENT_BATCH,
  payload: data,
});
export interface SetSuperPrintBatchAction extends Action<typeof SET_SUPER_PRINT_FULFILLMENT_BATCH> {
  readonly payload: ReadonlyArray<any>;
}

export interface GetSuperPendingFulfillmentPrintBatchAction extends Action<
  typeof SUPER_GET_PENDING_FULFILLMENT_PRINT_BATCH
> {
  readonly payload: ReadonlyArray<any>;
}

export interface SetSuperPendingFulfillmentPrintBatchAction extends Action<
  typeof SUPER_SET_PENDING_FULFILLMENT_PRINT_BATCH
> {
  readonly payload: ReadonlyArray<any>;
}

export type SuperAdminRydinFulfillmentsAction =
  | SuperSetPendingFulfillmentAction
  | SuperSetCompletedFulfillmentAction
  | SuperSetFulfillmentBatchesAction
  | SuperSetMultipleClientsAction
  | SuperSetFulfillmentsProcessBatchMultipleClientsAction
  | SuperSetPrintBulkBathcesAction
  | SetSuperFulfillmentProccessingResultAction
  | SetSuperPrintBatchAction
  | GetSuperPendingFulfillmentPrintBatchAction
  | SetSuperPendingFulfillmentPrintBatchAction;
